import Nav from '../components/nav/nav';
import Hero from '../components/hero';
import Tech from '../components/tech';
import About from '../components/about';
import RecentProject from '../components/recent_project';
import Contact from '../components/contact';
import Footer from '../components/nav/footer';

const Landing = () => {
  return (
    <div className="bg-gray-950">
      <Nav />
      <Hero />
      <Tech />
      <About />
      <RecentProject />
      <Contact />
      <Footer />
    </div>
  );
};

export default Landing;
